import React from "react"

const Container = props => {
  return (
    <section id="main" className={`container mx-auto py-10 ${props.classes}`}>
      {props.children}
    </section>
  )
}

export default Container
